import { merge, set, get, cloneDeep } from 'lodash';

import { buildCloudPayQuery } from '../utils/query';
const AVAILABLE_PAYMENT_METHODS = ['stripe', 'kushki', 'efecty'];
/**
 * @description Handles payment initial data fetch
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getPaymentMethodRequest = buildCloudPayQuery(
  ({ currentPaymentMethod }) => {
      let paymentMethod = currentPaymentMethod;
      // TODO: only allows stripe as new payment method
      if (!AVAILABLE_PAYMENT_METHODS.includes(currentPaymentMethod)) {
          paymentMethod = 'stripe';
      }

      return {
          url: `/client/payment/${paymentMethod}/config`,
          transform: (paymentConfig) => ({ paymentConfigs: { [paymentMethod]: paymentConfig } }),
          update: {
              paymentConfigs: merge,
          },
      };
  }
);

/**
 * @description Saves the payment new payment info into his respectively object into the paymentMethods array
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const updateProfilePaymentMethodRequest = buildCloudPayQuery(
  ({ paymentMethod, data }) => ({
    force: true,
    url: `/subscribers/payments/${paymentMethod}/profile`,
    options: {
      method: 'PUT'
    },
    body: {
      data
    }
  })
);

/**
 * @description Delete a user credit card
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const deleteCreditCardRequest = buildCloudPayQuery(
  ({ customerPaymentProfileId }) => ({
    force: true,
    url: `/subscribers/payments/authorizenet/profile?customerPaymentProfileId=${customerPaymentProfileId}`,
    update: {
      subscriber: (subscriber) => {
        const paymentProfiles = get(subscriber, 'paymentMethods.authorizenet.paymentProfiles', [])
          .filter((paymentProfile) => paymentProfile.customerPaymentProfileId !== customerPaymentProfileId);

        const newSubscriber = cloneDeep(subscriber);
        set(newSubscriber, 'paymentMethods.authorizenet.paymentProfiles', paymentProfiles);

        return newSubscriber;
      }
    },
    options: {
      method: 'DELETE'
    }
  })
);

/**
 * @description Apply discount code to a content
 *
 * @param {Object} [Request options]
 * @returns {QueryConfig}
 */
export const applyDiscountCodeRequest = buildCloudPayQuery(
  ({ code, ppvId }) => ({
    force: true,
    url: '/subscribers/payments/authorizenet/discount-code/',
    options: {
      method: 'POST'
    },
    body: {
      code,
      ppvId
    }
  })
);

export const GetExchangeRateRequest = buildCloudPayQuery(
  ({ paymentMethod, to }) => ({
    force: true,
    url: `/paymentExchange/${paymentMethod}/${to === 'OTHER' ? 'US' : to}`,
  })
);


/**
 * @description Handles payment initial data fetch
 *
 * @param {Object} [options]
 * @returns {QueryConfig}
 */
export const getSubPaymentMethods = buildCloudPayQuery(
  ({ paymentMethod }) => ({
    force: true,
    url: `/client/payment/${paymentMethod}/subPaymentMethods`,
    transform: subPaymentMethods => {
      return ({ subPaymentMethods: { [paymentMethod]: subPaymentMethods } })
    },
    update: {
      subPaymentMethods: merge
    }
  })
);

export default null;
